export const TIPO_EXCEPCION = {
  ABONO_MENOR: 1,
  GARANTIA_REPARACION: 2,
}

export const TIPO_EXCEPCION_LABELS = {
  [TIPO_EXCEPCION.ABONO_MENOR]: 'Abono Menor',
  [TIPO_EXCEPCION.GARANTIA_REPARACION]: 'Garantía de Reparación',
}
